import './App.css';
import { Grid, Toolbar } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import hotelBuilding from './pics/bgImage1.jpg';
import React, { Suspense, lazy, useEffect } from 'react';
import Navbar from './components/Navbar';
import { Box } from '@mui/system';
import Footer from './components/Footer';

import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider, useLanguage } from './context/LanguageContext';

// ✅ Lazy load each page (this is the key part)
const HomePage = lazy(() => import('./pages/Homepage'));

const Breakfast = lazy(() => import('./pages/Breakfast'));
const StandardImageList = lazy(() => import('./pages/ImageGallery'));
const FAQPage = lazy(() => import('./pages/Faq'));
const SirvoyBooking = lazy(() => import('./pages/SirvoyBooking'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const RoomGallery = lazy(() => import ('./pages/RoomGallery')); 

const menuItemsArray = ["Hem", "Boende", "Frukost", "Galleri", "Boka", "Faq", "Restaurang"];

const mainStyles = {
  firstSection: {
    minHeight: 'fit-content',
    maxHeight: 'fit-content',
    backgroundImage: `url(${hotelBuilding})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    justifyContent: "center",
    alignItems: "center",
  },
  otherSections: {
    padding: '2',
    minHeight: 'fit-content',
  },
};

// Language detector component
const LanguageDetector = () => {
  const { setLanguage } = useLanguage();
  const location = useLocation();

  useEffect(() => {
    // Check for language parameter in URL
    const urlParams = new URLSearchParams(location.search);
    const langParam = urlParams.get('lang');
    
    if (langParam && ['en', 'de', 'sv'].includes(langParam)) {
      setLanguage(langParam);
      // Optional: Remove the parameter from URL for cleaner sharing
      if (window.history.replaceState) {
        const newUrl = window.location.pathname + window.location.hash;
        window.history.replaceState({}, '', newUrl);
      }
    }
  }, [location.search, setLanguage]);

  return null;
};

function App() {
  return (
    <LanguageProvider>
      <HelmetProvider>
        <Router>
          <Box display="flex" flexDirection="column">
            <LanguageDetector />
            <Navbar menuItems={menuItemsArray} />
            <Toolbar /> {/* spacer to prevent overlap */}

            {/* ✅ Suspense will show fallback while a page loads */}
            <Suspense fallback={<div style={{ textAlign: 'center', padding: '50px' }}>Loading...</div>}>
              <Grid
                container
                spacing={0}
                component="main"
                justifyContent="center"
                alignItems="center"
                sx={{ flex: 1 }}
              >
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/hem" element={<HomePage />} />
                  <Route path="/boende" element={<RoomGallery />} />
                  <Route path="/frukost" element={<Breakfast />} />
                  <Route path="/galleri" element={<StandardImageList />} />
                  <Route path="/faq" element={<FAQPage />} />
                  <Route path="/boka" element={<SirvoyBooking />} />
                  <Route path="/kontakt" element={<ContactPage />} />
                </Routes>
              </Grid>
            </Suspense>

            <Footer />
          </Box>
        </Router>
      </HelmetProvider>
    </LanguageProvider>
  );
}

export default App;